import { useState } from "react";
import { after } from "underscore";
import CardSkeleton from "./CardSkeleton";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
function Images({ urls, setImage }) {
  const [loading, setLoading] = useState(true);
  const onComplete = after(urls.length, () => {
    setLoading(false);
  });

  // Placeholder for individual property photos (100x100)
  const thumbnailPlaceholder = "https://placehold.co/100x100?text=Photo";

  return (
    <>
      {/* {loading && <CardSkeleton cards={urls.length}/>} */}
      {urls.map((url, index) => (
        <img
          key={index}
          className="w-[100px] h-[100px] object-cover hover:cursor-pointer"
          src={cloudinaryUrl(url) || thumbnailPlaceholder}
          onClick={() => setImage(cloudinaryUrl(url) || thumbnailPlaceholder)}
          onLoad={onComplete}
          onError={(e) => {
            e.target.src = thumbnailPlaceholder;
            onComplete();
          }}
          alt="property"
        />
      ))}
    </>
  );
}
export default Images;
